let promise: Promise<boolean>;
export const detectAdBlock = async () => {
  if (typeof globalThis === "undefined") return false;
  promise ??= new Promise<boolean>(resolve => {
    const adsTestingUrl = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    const xhr = new XMLHttpRequest();
    xhr.timeout = 1000;
    xhr.addEventListener("readystatechange", function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        resolve(xhr.status === 0 || xhr.responseURL !== adsTestingUrl);
      }
    });
    xhr.open("HEAD", adsTestingUrl, true);
    xhr.send(null);
  });
  return promise;
};
